import React, { useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import { useState } from 'react';

const SubmitPopup = (props) => {
  const [show, setShow] = useState(false);

  const handleClose = () => {
    setShow(false);
    props.onClose(false);
  }
  useEffect(() => {
   
    setShow(props.show);
  }, [props.show]);
  return (
    <>
      <Modal show={show} onHide={handleClose} className='SubmitPopup'>
        <Modal.Header closeButton className='border-0'></Modal.Header>
        <Modal.Body className='text-center py-5'>
          <svg width="78" height="78" viewBox="0 0 78 78" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_113_322)">
              <path d="M42.2982 73.7798C61.5168 71.7083 75.4184 54.4594 73.3482 35.2533C71.278 16.0473 54.02 2.15707 34.8014 4.22862C15.5827 6.30017 1.68115 23.5491 3.75134 42.7551C5.82154 61.9611 23.0795 75.8514 42.2982 73.7798Z" fill="#9F7854" />
              <path d="M33.4835 57.1484L18.8401 42.1276L24.3222 36.7842L33.3144 46.0081L53.2186 24.3097L58.8613 29.4841L33.4835 57.1484Z" fill="white" />
            </g>
            <defs>
              <clipPath id="clip0_113_322">
                <rect width="70" height="70" fill="white" transform="translate(0 7.95245) rotate(-6.15208)" />
              </clipPath>
            </defs>
          </svg>
          <p className='pb-3 pt-3'>{props.title}</p>
        </Modal.Body>
      </Modal>
    </>
  )
}
export default SubmitPopup;